import { useTranslation } from "react-i18next";

const AboutTrbd = () => {
    const { t } = useTranslation();

    return (
        <section className="py-20 md:py-32 relative" id="about">
            <div className="container mx-auto px-6 relative">
                <div className="max-w-3xl mx-auto text-center">
                    {/* Top gradient divider */}
                    <div
                        aria-hidden
                        className="mx-auto mb-10 h-px w-40 opacity-70"
                        style={{
                            background:
                                "linear-gradient(90deg, transparent, hsl(260 90% 65%), hsl(190 90% 50%), transparent)",
                        }}
                    />

                    <p className="font-v2-label text-xs text-primary/80 mb-6">{t("about_home.eyebrow")}</p>

                    <h2 className="font-v2-display text-3xl md:text-5xl lg:text-6xl text-white leading-[1.15] mb-10">
                        {t("about_home.title_prefix")}{" "}
                        <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                            {t("about_home.title_highlight")}
                        </span>
                    </h2>

                    <p className="text-lg md:text-xl text-white/80 leading-[2] font-medium">
                        {t("about_home.body")}
                    </p>

                    <p className="mt-10 font-v2-display text-xl md:text-2xl text-white leading-relaxed">
                        {t("about_home.closing_prefix")}{" "}
                        <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                            {t("about_home.closing_highlight")}
                        </span>
                        {t("about_home.closing_suffix")}
                    </p>

                    <div
                        aria-hidden
                        className="mx-auto mt-12 h-px w-40 opacity-70"
                        style={{
                            background:
                                "linear-gradient(90deg, transparent, hsl(190 90% 50%), hsl(260 90% 65%), transparent)",
                        }}
                    />
                </div>
            </div>
        </section>
    );
};

export default AboutTrbd;
